import { render, staticRenderFns } from "./mockit.vue?vue&type=template&id=b3467404&scoped=true"
import script from "./mockit.vue?vue&type=script&lang=js"
export * from "./mockit.vue?vue&type=script&lang=js"
import style0 from "./mockit.vue?vue&type=style&index=0&id=b3467404&prod&scoped=true&lang=css"
import style1 from "./mockit.vue?vue&type=style&index=1&id=b3467404&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3467404",
  null
  
)

export default component.exports